import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import { getLocalStorage } from '../common/helpers/Utils';

let userInfo = getLocalStorage('userInfo');

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      getLocalStorage('userInfo') ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{ pathname: '/login', state: { from: props.location } }}
        />
      )
    }
  />
);

export default PrivateRoute;
